<div class="sidebar included">
	<app-sidebar-header [title]="'ancillaries.group.MilesEarned' | ibeadmin: 'sync'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>

		<app-included-per-passenger [flight]="flight" [brand]="brand" [feature]="feature" [passengers]="passengerList" *ngIf="flight">
		</app-included-per-passenger>


		<div class="sidebar-flight-text border">
			<h2 class="title-h2">
				{{ 'whatsIncludedSidebars.detailsLoyaltyMiles.title.tapMilesAndGo' | ibeadmin: 'sync' }}
			</h2>
			<div>
				<p>
					{{ 'whatsIncludedSidebars.detailsLoyaltyMiles.text.onlyFFMembers' | ibeadmin: 'sync' }}
				</p>

				<ul>
					<li>
						{{ 'whatsIncludedSidebars.detailsLoyaltyMiles.text.earnMilesInfotext1' | ibeadmin: 'sync' }}
					</li>
					<li>
						{{ 'whatsIncludedSidebars.detailsLoyaltyMiles.text.earnMilesInfotext2' | ibeadmin: 'sync' }}
					</li>
					<li>
						{{ 'whatsIncludedSidebars.detailsLoyaltyMiles.text.earnMilesInfotext3' | ibeadmin: 'sync' }}
					</li>
				</ul>
			</div>
			<p *ngIf="!isUserLogin">
				{{ 'whatsIncludedSidebars.detailsLoyaltyMiles.text.notYetAnFFMember' | ibeadmin: 'sync' }} 
				<a href="javascript:;" class="link extras-feature__link" (click)="INDRA_handleUserClick('user-info')">
					{{ 'whatsIncludedSidebars.detailsLoyaltyMiles.link.signUp' | ibeadmin: 'sync' }} 
				</a> 
				{{ 'whatsIncludedSidebars.detailsLoyaltyMiles.text.earnMilesNow' | ibeadmin: 'sync' }} 
			</p>
		</div>

		
		<app-compare-brands [feature]="feature" [brand]="brand" *ngIf="!reviewFlights && !timeToThinkFlights"></app-compare-brands>

		<p (click)="INDRA_goToUrl('externalURLs.earnMiles')">
			<a class="link" aria-label="Learn more, open window" href="javascript:;">
				{{ 'whatsIncludedSidebars.general.texts.learnMore' | ibeadmin: 'sync' }} 
			</a>
		</p>
		<div class="sidebar-flight-text border">
			<p>
				<a class="link extras-feature__link" 
					aria-label="Close dialog" 
					(click)="INDRA_handleClose()" 
					href="javascript:;" role="button">
					{{ 'whatsIncludedSidebars.detailsLoyaltyMiles.link.close' | ibeadmin: 'sync' }} 
				</a>
			</p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
